<template>
  <!-- https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/ -->
  <div class="text-center authentication-form">
    <form class="form-authentication" @submit.prevent="onSubmit">
      <!-- <img class="mb-4" src="../../assets/brand/bootstrap-solid.svg" alt="" width="72" height="72"> -->
      <!-- <img class="mb-4" src="../assets/img/logo/logo-dame-una-mano_imageonly_purple.svg" alt="" width="72" height=""> -->

      <div v-if="tokenValid && (passwordResetSuccessfully == null)">
        <h3 class="mb-3" style="color: var(--coredarkcolor);">New Password</h3>

        <!-- <label for="inputEmail" class="sr-only">Email</label> -->
        <!-- <input type="email" id="inputEmail" class="form-control" placeholder="Correo Electrónico" required autofocus v-model="email"> -->
        <label for="inputPassword" class="sr-only">Password</label>
        <input type="password" id="inputPassword" class="form-control" placeholder="New Password" required v-model="password">

        <button class="btn btn-lg btn-primary btn-block" type="submit">Reset</button>
      </div>

      <div v-if="!tokenValid">
        <p>Your reset password link is no longer valid. Please click the button to try again</p>
        <router-link :to="{ name: 'Password Reset Request' }" class="btn btn-primary">Reset Password</router-link>
      </div>

      <div v-if="passwordResetSuccessfully == false">
        <p>Sorry! There was a problem resetting your password. Please click the button to try again.</p>
        <router-link :to="{ name: 'Password Reset Request' }" class="btn btn-primary">Reset Password</router-link>
      </div>

      <div v-if="passwordResetSuccessfully == true">
        <p>Your password was successfully reset! Please click the button to log in to your account.</p>
        <router-link :to="{ name: 'Login' }" class="btn btn-primary">Login</router-link>
      </div>

      <!-- <p class="pt-4 pb-5 text-muted">¿Preguntas? 350-4775478</p> -->
      <!-- {{ token }} -->
    </form>
  </div>
</template>

<script>
  import axios from 'axios'; // Don't have to name it axios, can name it anything - Lecture 348

  export default {
    data() {
      return {
        token: null,
        password: '',

        tokenValid: false,
        passwordResetSuccessfully: null,
      }
    },
    created () {
      this.token = this.$route.params.token
      //  this.getUser()
      this.checkToken() // When someone visits this page by clicking the link in their email, first step is to check if their token is valid

    },
    methods: {
      checkToken() {
        console.log(this.token)
        // axios.post('/api/password_reset/reset_password/validate_token/', {
        axios.post('/check-token/', {
          token: this.token,
        })
          .then(res => {
            console.log(res)
            console.log('Token is good')
            this.tokenValid = true
          })
          .catch(error => {
            console.log(error)
            console.log('Token is bad')
            this.tokenValid = false
          })
      },
      onSubmit () {
        // axios.post('/api/password_reset/reset_password/confirm/', {
        axios.post('/reset-password/', {
          token: this.token,
          password: this.password,
        })
          .then(res => {
            console.log(res)
            console.log('Password Reset!')
            this.passwordResetSuccessfully = true
          })
          .catch(error => {
            console.log(error)
            console.log('Password not reset...')
            this.passwordResetSuccessfully = false
          })
      },
    }
  }
</script>

<style>
  .form-authentication input[type="password"] {
    margin-bottom: 10px;
    /* border-bottom-right-radius: 0; */
    /* border-bottom-left-radius: 0; */
  }
</style>



// WEBPACK FOOTER //
// src/components/password/PasswordReset.vue